<mat-drawer-container class="absoluteFill customDrawer" [hasBackdrop]="false">
  <mat-drawer class="detailsPanelContainer" [opened]="!!expandedElementDetailed" position="end" [mode]="'over'" >
    <div class="detailsPanel">
      <mat-toolbar class="detailsPanelToolbar">
        <div fxFlex fxLayout="column">
          <span class="detailsPanelToolbarTitle" fxFlex>{{expandedElementDetailed?.name}}</span>
          <span class="detailsPanelToolbarSubtitle" fxFlex>{{'PRODUCTITEM.DETAILS' | translate}}</span>
        </div>
        <button mat-icon-button color="accent" (click)="expandedElementDetailed = undefined">
          <mat-icon>close</mat-icon>
        </button>
        <section class="floatingUpdateButton" *ngIf="gmService.isTenantAdmin()">
          <button mat-fab color="primary" *ngIf="!editMode" (click)="editMode = true">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-fab color="primary" style="margin-right: 15px;" *ngIf="editMode" [disabled]="!formValidationOk" (click)="updateProductItem()">
            <mat-icon>done</mat-icon>
          </button>
          <button mat-fab color="primary" *ngIf="editMode" (click)="editMode = false">
            <mat-icon>close</mat-icon>
          </button>
        </section>
      </mat-toolbar>

      <app-customer-productItem-detail fxFlex
                                       (close)="hideElement()"
                                       (validForm)="manageFormValidation($event)"
                                       [editMode]="editMode"
                                       [selectedRow]="expandedElementDetailed"
                                       [isOnChirpstack]="isOnChirpstack"
                                       (refresh)="showDetail($event, true)"
      ></app-customer-productItem-detail>

    </div>
  </mat-drawer>


  <mat-drawer-content>
    <div class="drawerContent absoluteFill" fxLayout="column">
      <div fxLayout="row" fxLayoutGap="10px grid" >
        <!--  ************************************  -->
        <!--          CUSTOMER SELECTION            -->
        <!--  ************************************  -->
        <mat-form-field class="fullWidthField">
          <mat-label>{{'PRODUCTITEM.CUSTOMER' | translate}}</mat-label>

          <input type="text" matInput class="mat-typography" #customerSelect (focus)="customerSelect.select()" [matAutocomplete]="auto" [formControl]="customerSelectionControl" name="parentCustomerId" [(ngModel)]="selectedCustomer" >
          <mat-autocomplete #auto="matAutocomplete" requireSelection (optionSelected)="expandedElementDetailed = undefined; getCustomerProductItems()" [displayWith]="displayFn">
            <mat-option  *ngFor="let customer of filteredCustomers | async" [value]="customer"><span class="mat-typography">{{customer.title}}</span></mat-option>
          </mat-autocomplete>
          <button mat-icon-button matSuffix color="primary" [disabled]="!customerSelectionControl.value" (click)="clearSelection()">
            <mat-icon>close</mat-icon>
          </button>

        </mat-form-field>

      </div>


      <div fxFlex class="mat-elevation-z8 table-container" fxLayout="column" *ngIf="!!productItems">

        <!-- ####################################################################################################### -->
        <!-- Main Toolbar                                                                                            -->
        <!-- ####################################################################################################### -->
        <mat-toolbar class="tableToolbar" fxLayout="row" *ngIf="!searchEnabled">
          <span fxFlex>
            Installazioni {{selectedCustomer?.title}}
          </span>
          <div fxFlex class="tableToolbarButtons">
            <button mat-icon-button color="primary" *ngIf="gmService.isTenantAdmin()" (click)="addNewProductItem()">
              <mat-icon>add</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="getCustomerProductItems()">
              <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="enableSearch()">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </mat-toolbar>

        <!-- ####################################################################################################### -->
        <!-- Search Toolbar                                                                                          -->
        <!-- ####################################################################################################### -->
        <mat-toolbar class="tableToolbar" fxLayout="row" *ngIf="searchEnabled">

          <mat-form-field fxFlex>
            <mat-label>&emsp;</mat-label>

            <input matInput placeholder="{{'PRODUCTITEM.SEARCH' | translate}}" type="text" name="productItemSearch" autofocus #filterValue="ngModel"
                   [(ngModel)]="productItemNameToFind" (keyup.enter)="getCustomerProductItems()">

          </mat-form-field>

          <button mat-icon-button color="primary" (click)="searchEnabled = false; productItemNameToFind = undefined; getCustomerProductItems();">
            <mat-icon>close</mat-icon>
          </button>
        </mat-toolbar>

        <div fxFlex class="table-container">
          <table mat-table class="alsoMobileTable"  [dataSource]="tableDataSource" aria-describedby="customerProductItems">

            <!-- ProductItem Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> {{'PRODUCTITEM.NAME' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- ProductItem label Column -->
            <ng-container matColumnDef="label">
              <th mat-header-cell *matHeaderCellDef> {{'PRODUCTITEM.LABEL' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.label}} </td>
            </ng-container>

            <ng-container matColumnDef="daeFeature">
              <th mat-header-cell *matHeaderCellDef> {{'PRODUCTITEM.DAE_COL' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div fxLayout="row">
                  <div fxFlex *ngIf="element.hasDae">
                    <img alt="daeLogo" src="assets/daeLogo.png">
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="e015Feature">
              <th mat-header-cell *matHeaderCellDef> {{'PRODUCTITEM.E015_COL' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div *ngIf="element.isE015">
                  <img alt="e015Logo" src="assets/e015Logo.png">
                </div>
              </td>
            </ng-container>

            <!-- Product_Type firstname Column -->
            <ng-container matColumnDef="monitored">
              <th mat-header-cell *matHeaderCellDef> {{'PRODUCTITEM.MONITORED' | translate}} </th>
              <td mat-cell *matCellDef="let element"> <mat-icon  [ngClass]="getYesNoIconClass(element.isMonitored)" >{{element.isMonitored? 'check' : 'close'}}</mat-icon> </td>
            </ng-container>

            <!-- ProductItem label Column -->
            <ng-container matColumnDef="registryStatus">
              <th mat-header-cell *matHeaderCellDef> {{'PRODUCTITEM.WORKFLOW_STATUS' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div>
                  <mat-icon [ngClass]="getClassForWorkflowStatusIcon(element)">circle</mat-icon>
                  <span class="textAlignedWithIcon">{{'PRODUCTITEM.REGISTRY_STATUS.' + element.registryStatus | translate}}</span>
                </div>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions" >
              <th mat-header-cell *matHeaderCellDef></th>


              <td mat-cell *matCellDef="let element"  [ngClass]="(gmService.isMobileScreen() || gmService.isTenantUser()) ? 'smallIcons' : 'normalIcons'">

                <!-- COLLAPSED ICONS -->
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation();" *ngIf="gmService.isMobileScreen()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item color="primary" [disabled]="!element.isMonitored" (click)="openProductItemTokenDialog(element); $event.stopPropagation();" [title]="'PRODUCTITEM.COPY_TOKEN' | translate">
                    <mat-icon mat-list-icon>password</mat-icon> {{'PRODUCTITEM.COPY_TOKEN' | translate}}
                  </button>
                  <button mat-menu-item color="primary"  [disabled]="!element.isMonitored" *ngIf="gmService.isTenantAdmin()" (click)="changeWorkflowStatus(element); $event.stopPropagation();" [title]="'PRODUCTITEM.CHANGE_WORKFLOW_STATUS' | translate">
                    <mat-icon mat-list-icon>quiz</mat-icon> {{'PRODUCTITEM.CHANGE_WORKFLOW_STATUS' | translate}}
                  </button>
                  <button mat-menu-item color="primary" *ngIf="gmService.isTenantAdmin() && gmService.osmEnabled" [disabled]="element.hasOsmUrl" (click)="publishToOSM(element); $event.stopPropagation();" [title]="(element.hasOsmUrl) ? ('PRODUCTITEM.PUBLISH_TO_OSM' | translate) : ('PRODUCTITEM.ALREADY_PUBLISHED_TO_OSM' | translate)">
                    <mat-icon mat-list-icon>location_on</mat-icon> {{(!element.hasOsmUrl) ? ('PRODUCTITEM.PUBLISH_TO_OSM' | translate) : ('PRODUCTITEM.ALREADY_PUBLISHED_TO_OSM' | translate)}}
                  </button>
                  <button mat-menu-item color="primary" *ngIf="gmService.isTenantAdmin()" (click)="changeProductItemOwner(element); $event.stopPropagation();" [title]="'PRODUCTITEM.CHANGE_OWNER' | translate">
                    <mat-icon mat-list-icon>assignment_ind</mat-icon> {{'PRODUCTITEM.CHANGE_OWNER' | translate}}
                  </button>
                  <button mat-menu-item color="primary" *ngIf="gmService.isTenantAdmin()" (click)="deleteProductItem(element); $event.stopPropagation();" [title]="'PRODUCTITEM.DELETE' | translate">
                    <mat-icon mat-list-icon>delete</mat-icon> {{'PRODUCTITEM.DELETE' | translate}}
                  </button>
                </mat-menu>


                <!-- INLINE ICONS -->
                <div *ngIf="!gmService.isMobileScreen()">
                  <button mat-icon-button color="primary" [disabled]="!element.isMonitored" (click)="openProductItemTokenDialog(element); $event.stopPropagation();" [title]="'PRODUCTITEM.TOKEN' | translate">
                    <mat-icon>password</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" *ngIf="gmService.isTenantAdmin()" (click)="changeWorkflowStatus(element); $event.stopPropagation();" [title]="'PRODUCTITEM.CHANGE_WORKFLOW_STATUS' | translate">
                    <mat-icon>quiz</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" *ngIf="gmService.isTenantAdmin() && gmService.osmEnabled" [disabled]="element.hasOsmUrl" (click)="publishToOSM(element); $event.stopPropagation();"
                          [title]="(!element.hasOsmUrl) ? ('PRODUCTITEM.PUBLISH_TO_OSM' | translate) : ('PRODUCTITEM.ALREADY_PUBLISHED_TO_OSM' | translate)">
                    <mat-icon>location_on</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" *ngIf="gmService.isTenantAdmin()" (click)="changeProductItemOwner(element); $event.stopPropagation();" [title]="'PRODUCTITEM.CHANGE_OWNER' | translate">
                    <mat-icon>assignment_ind</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" *ngIf="gmService.isTenantAdmin()" (click)="deleteProductItem(element); $event.stopPropagation();" [title]="'PRODUCTITEM.DELETE' | translate">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="{'highlight': expandedElementDetailed?.id == row.id}"
                (click)="showDetail(row)"></tr>

            <!--  ************************************  -->
            <!--               NO DATA ROW              -->
            <!--  ************************************  -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [colSpan]="displayedColumns.length">{{'COMMON.NO_DATA_FOUND' | translate }}</td>
            </tr>
          </table>

          <div *ngIf="customerProductItemsLoading"
               style="display: flex; justify-content: center; align-items: center; background: white;">
            <mat-progress-spinner
              [diameter]="40"
              color="primary"
              mode="indeterminate">
            </mat-progress-spinner>
          </div>
        </div>

        <mat-divider></mat-divider>
        <mat-paginator showFirstLastButtons class="paginatorCustom" (page)="getPaginatorData($event)" [length]="totalElements" [pageSize]="pageSize" [pageSizeOptions]="PAGESIZE_OPTIONS"></mat-paginator>

      </div>

    </div>
  </mat-drawer-content>
</mat-drawer-container>
